import Permissions from '@/app/permissions/Permissions';
import hasRequiredPermissions from '@/common-utils/functions/hasRequiredPermissions';

const POS_TERMINALS_TABS = {
    SUBSCRIPTIONS:
    {
        name: 'subscriptions',
        hasPermissions: (permissions) => hasRequiredPermissions({ permissions, requiredPermissions: [Permissions.SUBSCRIPTION_LIST.name] })
    },
    PAYLUDD_SUBSCRIPTIONS:
    {
        name: 'payludd_subscriptions',
        hasPermissions: (permissions) => hasRequiredPermissions({ permissions, requiredPermissions: [Permissions.ANDROID_MANAGE_PACKAGE.name] })
    }
};

POS_TERMINALS_TABS.DEFAULT = POS_TERMINALS_TABS.SUBSCRIPTIONS;

export default POS_TERMINALS_TABS;